<template>
  <div>
    <div class="m-b-20 s_flex_ali">
      <div class="p-r-15 width-140">
        <a-button :type="search.type == 0 ? 'primary':''" block @click='typeCheck(0)'>每日数量统计</a-button>
      </div>
      <div class="p-r-15 width-140">
        <a-button :type="search.type == 1 ? 'primary':''" block @click='typeCheck(1)'>发放渠道统计</a-button>
      </div>
      <div class="p-r-15 width-140">
        <a-button :type="search.type == 2 ? 'primary':''" block @click='typeCheck(2)'>消耗渠道统计</a-button>
      </div>
    </div>
    <div>
       <a-range-picker  @calendarChange="onCalendarChange" :disabledDate='disabledDate'  v-model:value='time'  valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" :offsetDays="offsetDays" />
      <a-button type="primary" @click='pageSearchChange'>搜索</a-button>
      <span class="s_c999">（最大查询日期区间为30天）</span>
    </div>
    <div class="p-t-20" v-if='!listLoading && search.type == 0'>
      <echartLine :echartsData='echartData' v-if='!listLoading'></echartLine>
    </div>
    <div class='m-t-20'>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='date' :columns='columns' :data-source='data'>
      </a-table>
      <a-pagination v-if='search.type == 0' :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper
        :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange"
        @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </div>
  </div>
</template>
<script>
  import { reactive, ref, toRefs, onMounted,inject } from 'vue';
  import { getIntegralGeneralLog } from "@/api/assets";
  import { iscode } from '@/utils/app';
  // 初始化默认筛选项数值
  let defSearch = {
    type: 0,
    page: 1,
    limit: 10,
    start_time: '',
    end_time: ''
  };
  export default {
    name: "integralGeneral",
    setup() {
      const search = ref({ ...defSearch });
      const state = reactive({
        offsetDays:2678400 * 1000,
        listLoading: false,
        total: 0,
        time: [],
        columns: [],
        echartData:{},
        dayColumns: [
          {
            title: "日期",
            dataIndex: "date",
            key: "date",
          },
          {
            title: "总发放数量",
            dataIndex: "grant_point_total",
            key: "grant_point_total",
          },
          {
            title: "总消耗数量",
            dataIndex: "consume_point_total",
            key: "consume_point_total",
          },
        ],
        generalColumns: [
          {
            title: "发放渠道",
            dataIndex: "type_text",
            key: "type_text",
          },
          {
            title: "总发放数量",
            dataIndex: "point_total",
            key: "point_total",
          },
          {
            title: "占比",
            dataIndex: "percentage",
            key: "percentage",
          },
        ],
        useColumns: [
          {
            title: "消耗渠道",
            dataIndex: "type_text",
            key: "type_text",
          },
          {
            title: "总消耗数量",
            dataIndex: "point_total",
            key: "point_total",
          },
          {
            title: "占比",
            dataIndex: "percentage",
            key: "percentage",
          },
        ]
      })
      let data = ref();

      const initData = async (values) => {
        state.listLoading = true;
        data.value = [];
        state.total = 0;
        let res = await getIntegralGeneralLog(values).then(res => res.data);
        state.listLoading = false;
        if (iscode(res)) {
          if(search.value.type == 0){
            var grant = [];
            var consume = [];
            var day = [];
            data.value = res.data.totalList.data;
            state.total = res.data.totalList.total;
            state.echartData.dataName = ['总发放量', '总消耗量']
            res.data.lineList.map(v => grant.push(v.grant_point_total))
            res.data.lineList.map(v => consume.push(v.consume_point_total))
            res.data.lineList.map(v => day.push(v.date))
            state.echartData.latelyDays = day
            state.echartData.series = [
              {
                name: '总发放量',
                data: grant,
                type: 'line',
                symbolSize: 6,smooth: true
              },
              {
                name: '总消耗量',
                data: consume,
                type: 'line',
                symbolSize: 6,smooth: true
              },
            ]
          }else{
            data.value = res.data
          }
        }
        state.listLoading = false;
      };
      //时间筛选
      const onChange = (e) => {
        search.value.start_time = e[0]
        search.value.end_time = e[1]
      }
      const typeCheck = (e) => {
        if (e == search.value.type) {
          return false
        }
        if (e == 0) {
          state.columns = state.dayColumns
        } else if (e == 1) {
          state.columns = state.generalColumns
        } else {
          state.columns = state.useColumns
        }
        search.value.type= e
        state.time = []
        initData({...search.value,page:1,start_time:'',end_time:'',type:e})
      }
      // 页面筛选项搜索
      const pageSearchChange = () => {
        search.value = { ...search.value, page: 1 };
        initData(search.value);
      };
      // 分页当前页切换
      const pageCurrentChange = (page, pageSize) => {
        search.value.page = page;
        initData(search.value);
      };
      // 分页当前页显示多少条切换
      const pageSizeChange = (current, limit) => {
        search.value.page = 1;
        search.value.limit = limit;
        initData(search.value);
      };
      onMounted(() => {
        initData(search.value)
        state.columns = state.dayColumns
      });
    const disabledDate = current => {
      if (!state.time || state.time.length === 0) {
        return false;
      }

      const diffDate = current.diff(state.time[0], 'days');
      return Math.abs(diffDate) > 30;
    }
     const onCalendarChange = val => {
      state.time = val;
    };
      return {
        ...toRefs(state),
        search,
        data,
        pageSearchChange,
        pageCurrentChange,
        pageSizeChange,
        onChange,
        typeCheck,
        disabledDate,
        onCalendarChange
      }
    }
  }
</script>